import { combineReducers } from 'redux-immutable';

// global store
import bannerAppData from 'src/store/appBanners/slice';
import feedback from '../../../store/feedback/slices';
import client from '../../../store/client/reducers';
import logo from '../../../store/logo/reducers';
import menu from '../../../store/menu/slice';
import payment from '../../../store/payment/reducer';
import enqueue from '../../../store/enqueue/reducers';
import headerWidget from '../../../store/headerWidget/reducers';
import wishlist from '../../../store/wishlist/slice';

import certificate from './certificate/slice';
import view from './view/slice';

const rootReducer = combineReducers({
  feedback,
  client,
  logo,
  menu,
  payment,
  enqueue,
  headerWidget,
  wishlist,
  bannerAppData,
  //
  view,
  certificate,
});

export default rootReducer;
